









import Habit from "@/types/Habit";
import getHabitSuccessTotalByYearMonth from "@/utils/getHabitSuccessTotalByYearMonth";
import monthName from "@/utils/monthName";
import Vue from "vue";
export default Vue.extend({
  props: {
    habit: Object as () => Habit,
    month: Number as () => number,
    year: Number as () => number,
  },
  computed: {
    success() {
      return getHabitSuccessTotalByYearMonth(this.month, this.year, this.habit);
    },
    total() {
      const monthDate = new Date(
        this.year as number,
        (this.month as number) + 1,
        0
      );
      const totalDaysInMonth = monthDate.getDate();
      let total = 0;
      for (let day = 1; day <= totalDaysInMonth; day++) {
        monthDate.setDate(day);
        const weekDay = monthDate.getDay();
        const dayCounts = (this.habit as Habit).repeatsOn[weekDay];
        if (dayCounts) {
          total++;
        }
      }
      return total;
    },
  },
});
